import type { MerchantsTab } from '../model/list-params';
import type { BusinessType, ClientType, VendorStatusFilter } from '../model/schema';

/**
 * Static registries for the legacy clients view (ported from cpanel
 * `assets/data/user-statuses.ts` + `features/clients/model/columns.tsx`).
 * Labels resolve through i18n at render time; only ids/keys live here.
 */

export interface ClientTabDef {
  id: ClientType;
  /** i18n key under `merchants:clients.tabs.*`. */
  labelKey: string;
}

export const CLIENT_TABS: readonly ClientTabDef[] = [
  { id: 'all-vendor', labelKey: 'merchants:clients.tabs.allVendor' },
  { id: 'business-vendor', labelKey: 'merchants:clients.tabs.business' },
  { id: 'vendor', labelKey: 'merchants:clients.tabs.vendor' },
  { id: 'employees', labelKey: 'merchants:clients.tabs.employees' },
  { id: 'client', labelKey: 'merchants:clients.tabs.client' },
] as const;

/**
 * Top-level `/merchants` tab → legacy segment served by the shared clients
 * table. Every tab hits the same legacy clients API; the tab only pins the
 * default dataset (`Тип клиента` is no longer user-switchable):
 * merchants = Бизнесы, clients = Клиенты, employees = Сотрудники.
 */
export const TAB_DEFAULT_CLIENT_TYPE: Record<MerchantsTab, ClientType> = {
  merchants: 'business-vendor',
  clients: 'vendor',
  employees: 'employees',
};

export const BUSINESS_TYPE_OPTIONS: readonly { value: BusinessType; labelKey: string }[] =
  [
    { value: 'ALL', labelKey: 'merchants:clients.business.all' },
    { value: 'CORPORATE', labelKey: 'merchants:clients.business.corporate' },
    { value: 'NON-CORPORATE', labelKey: 'merchants:clients.business.nonCorporate' },
  ] as const;

export const VENDOR_STATUS_OPTIONS: readonly {
  value: VendorStatusFilter;
  labelKey: string;
}[] = [
  { value: 'active', labelKey: 'merchants:clients.status.active' },
  { value: 'archive', labelKey: 'merchants:clients.status.archive' },
] as const;

/** Vendor status cell meta (cpanel `STATUS_META`): anything else renders raw. */
export const VENDOR_STATUS_META: Record<
  string,
  { labelKey: string; tone: 'active' | 'neutral' }
> = {
  active: { labelKey: 'merchants:clients.status.active', tone: 'active' },
  archive: { labelKey: 'merchants:clients.status.archive', tone: 'neutral' },
};

/** Fields the legacy grid can sort (CustomHeader cycle, single active). */
export const CLIENT_SORT_FIELDS = [
  'created_date',
  'total_order_price',
  'orders_count',
  'balance',
  'diff_balance',
  'average_cheque',
] as const;
export type ClientSortField = (typeof CLIENT_SORT_FIELDS)[number];
